import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteChartV3Params {
  params: OpalApiRequestParams<'DeleteChartV3'>
}

export const deleteChart = async ({
  params,
}: DeleteChartV3Params): Promise<null> => {
  const url = new URL(
    `/loupe/v3/charts/${params.path.chart_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
